/* eslint-disable max-len */
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import _ from 'lodash';

// import { analytics } from 'common/utils';
import { Responsive } from 'common/components';
import v1LogoImg from 'assets/client/imgs/v1-logo.jpg';
import galgalazLogoImg from 'assets/client/imgs/Galgalz.svg';
import centerLogoImg from 'assets/client/imgs/site-logo.svg';
import liveEventsLogo from 'assets/client/imgs/live-events-logo.svg';
// import mobileCategoryLogoImg from 'assets/client/imgs/small-site-logo.png';

import Container from '../Container';
import Socials from './Socials';
import * as css from './Header.scss';

class Header extends React.PureComponent {
	static propTypes = {
		className: PropTypes.string,
		match: PropTypes.shape({
			params: PropTypes.shape({
				categoryId: PropTypes.string,
			}),
		}).isRequired,
		isHideInHeader: PropTypes.bool,
		isSticky: PropTypes.bool,
		isHiddenOnMain: PropTypes.bool,
		categoryMobileTitle: PropTypes.string,
		// isHideSocialsOnMobie: PropTypes.bool,
		isScrolling: PropTypes.bool,
		// isShowPseudo: PropTypes.bool,
	};

	static defaultProps = {
		className: '',
		isHideInHeader: false,
		isSticky: true,
		isHiddenOnMain: false,
		categoryMobileTitle: '',
		// isHideSocialsOnMobie: false,
		isScrolling: false,
		// isShowPseudo: false,
		// isCategory: false,
	};

	onV1LogoClick = () => {
		// analytics.onMakoLogoClick();
	};

	onGlglzLogoClick = () => {
		// analytics.onGlglzLogoClick();
	};

	render() {
		const { className, isHideInHeader, isSticky, isHiddenOnMain, categoryMobileTitle, isScrolling } = this.props;

		const v1Link = 'https://www.v-1.co.il';
		const galgalazLink = 'https://glz.co.il/%D7%92%D7%9C%D7%92%D7%9C%D7%A6';

		return (
			<div
				className={classNames(
					css.header,
					{ [css.isHideInHeader]: isHideInHeader },
					!isSticky && css.fixed,
					className
				)}
			>
				<Container className={css.headerContent}>
					<div className={css.rightPart}>
						<div className={css.logos}>
							<a href={v1Link} onClick={this.onV1LogoClick} target="_blank" rel="noopener noreferrer">
								<img className={css.v1Logo} src={v1LogoImg} alt="V1 logo" />
							</a>
							<a
								href={galgalazLink}
								target="_blank"
								rel="noopener noreferrer"
								onClick={this.onGlglzLogoClick}
							>
								<img className={css.galgalazLogo} src={galgalazLogoImg} alt="galgalaz logo" />
							</a>
							<img src={liveEventsLogo} alt="live events" className={css.liveEventsLogo} />
						</div>
					</div>
					{!isHiddenOnMain && !isScrolling && (
						<div className={css.centralPart}>
							<div className={css.logoWrap}>
								<img className={css.logo} src={centerLogoImg} alt="galgalaz logo" />
							</div>
							{/* <Responsive query={Responsive.DESKTOP}>
							<p className={css.textOnScroll}>הצביעו לאנשי השנה לשנת</p>
						</Responsive> */}
						</div>
					)}
					<div className={css.leftPart}>
						<Socials className={css.socials} />
						{/* {Responsive.isMatching(Responsive.MOBILE) && !isHideSocialsOnMobie && (
							<Socials className={css.socials} />
						)} */}
					</div>
					<Responsive query={Responsive.MOBILE}>
						<div className={css.textOnScroll}>
							<p className={css.categoryText}>{categoryMobileTitle}</p>
							{/* <div className={css.mobileCategoryLogo}>
								<img src={mobileCategoryLogoImg} alt="site logo" />
							</div> */}
						</div>
					</Responsive>
				</Container>
			</div>
		);
	}
}

export default withRouter(Header);
